<template>
<router-view />
</template>

<script>
export default {
  name: 'Report',
  routeInfo: {
    label: '分析报告',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/03Report/index.vue